import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label } from 'ng2-charts';
import { DashboardService } from './dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
   
   
   // Doughnut
   datasets:any[]=[
     {
       backgroundColor:[
         "#FF6384",
         "#36A2EB",
         "#FFCE56"
       ],
       hoverBackGroundColor:[
         "#000",
         "#36A2EB",
         "#FFCE56"
       ]
     }
   ];
    doughnutChartLabels: Label[] = [];
    count:any=[];
    doughnutChartData: MultiDataSet = [[],];
    
    doughnutChartType: ChartType = 'doughnut';
    chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { position: 'bottom' }
   }
   counto;
  partnersList:any=[];
  partnerCountList:any=[];
  totalPartners:number=0;
  constructor(private dashboardService:DashboardService) { }

  ngOnInit() {
    this.getPartnersCount();
    this.getPartnersCountByType();
    this.getTop5Partners();
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }
  getPartnersCount() {
    this.dashboardService.getPartnerCount().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.totalPartners = response['result'];
      }
    });
  }
    getPartnersCountByType() {
      this.dashboardService.getPartnerCountByType().subscribe(response => {
        let labels=[];
        if (response['code'] == 'S0000') {
          this.partnerCountList = response['result'];
          for(let item of this.partnerCountList){
          labels.push(item.partnerType);
          this.count.push(item.total);
          }
          this.doughnutChartLabels=labels;
         this.doughnutChartData=this.count;
        }
      });
    }
      getTop5Partners() {
        this.dashboardService.getTop5Partners().subscribe(response => {
          if (response['code'] == 'S0000') {
            this.partnersList = response['result'];
            
          }
        });      }

}
